import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VisitorDashboardComponent } from './visitor-dashboard/visitor-dashboard.component';
import { VisitorComponent } from './visitor/visitor.component';
import { InductionTrainingPaperComponent } from './induction-training-paper/induction-training-paper.component';
import { AfterPreRequestVisitorComponent } from './after-pre-request-visitor/after-pre-request-visitor.component';
import { VisitorSafetyTrainingPaperComponent } from './visitor-safety-training-paper/visitor-safety-training-paper.component';
import { GenerateQrVisitorComponent } from './generate-qr-visitor/generate-qr-visitor.component';
import { AuthGuard } from '../auth.guard';
import { PublicGuard } from '../public.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'visitor-dashboard',
    pathMatch: 'full'
  },
  {
    path: 'visitor',
    component: VisitorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'visitor-dashboard',
    component: VisitorDashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'after-pre-request/:id',
    component: AfterPreRequestVisitorComponent,
    canActivate: [PublicGuard]
  },
  {
    path: 'induction-training-paper',
    component: InductionTrainingPaperComponent,
    canActivate: [PublicGuard]
  },
  {
    path: 'Visitor_SafetyTraining_Paper',
    component: VisitorSafetyTrainingPaperComponent,
    canActivate: [PublicGuard]
  },
  {
    path: 'profile-qr-generate',
    component: GenerateQrVisitorComponent,
    canActivate: [PublicGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VisitorManagementRoutingModule { }
